

import { BrowserRouter, Route, Routes } from "react-router-dom";
import ReactGA from 'react-ga';
import "./App.css";
import "react-toastify/dist/ReactToastify.css";
import './assets/styles/main.css'
import React, { Suspense, lazy, useEffect } from "react";
import Loader from "./reusable_components/loader";
import BadRequest from "./reusable_components/badRequest";
import LandingPage from "./containers/landing/index";
import PrivateRoutes from "./containers/private_Routes/PrivateRoutes";
import SecLandingPage from "./containers/secLanding";
import ThankYouPage from "./containers/thankyou";
import { useNetworkStatus } from "./services/networkStatus";
import LandingSearch from "./containers/tracking/qrScanDetails";

function App() {

  useEffect(() => {
    ReactGA.initialize('G-D8ST7WW49P');
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  const Login = lazy(() => import('./containers/authentication/login_page/login'));
  const OTP = lazy(() => import('./containers/authentication/login_page/otp'));
  const Dashboard = lazy(() => import('./containers/dashboard'));
  const ProfileMainPage = lazy(() => import('./containers/profile/profileMainPage'));
  const Support = lazy(() => import('./containers/dashboard/support'));
  const AddProduct = lazy(() => import('./containers/product'));
  const ProductInventoryView = lazy(() => import('./containers/product_Inventory'));
  const ProductDetails = lazy(() => import('./containers/product_Inventory/productDetails'));
  const ReportSection = lazy(() => import('./containers/warranty'));
  const QRSuccess = lazy(() => import('./containers/product/generate_QR_IOT/QRSuccess'));
  const BlockchainExplorer = lazy(() => import('./containers/blockchain-explorer'));
  const BlockchainExplorerDetails = lazy(() => import('./containers/blockchain-explorer/blockchain_details'));
  const Privacy = lazy(() => import('./containers/footer/privacy'));
  const TermsAndConditions = lazy(() => import('./containers/footer/termsAndConditions'));
  
   const isOnline = useNetworkStatus();

  return (
    <div>
         {!isOnline && (
        <div className="network-banner">
          You’re offline. Some features may not work.
        </div>
      )}
      <BrowserRouter>
        <Routes>
          <Route path="/" element={<LandingPage />} />
          <Route path="/holografs-anti-counterfeit-solution" element={<SecLandingPage />} />
          <Route path="/thankyou" element={<ThankYouPage />} />
          <Route path="*" element={<BadRequest />} />
          <Route path="/productTracking/:id" element={<LandingSearch />} />
          {/* <Route path="/notification" element={<PrivateRoutes><Notification /></PrivateRoutes>}/> */}

          {/* Authentication */}
          <Route path="/login" element={<Suspense fallback={<Loader />}><Login /></Suspense>} />
          <Route path="/otp" element={<Suspense fallback={<Loader />}><OTP /></Suspense>} />

          {/* Dashboard */}
          <Route path="/dashboard" element={<PrivateRoutes><Suspense fallback={<Loader />}><Dashboard /></Suspense></PrivateRoutes>} />

          {/* Dashboard Items */}
          <Route path="/support" element={<PrivateRoutes><Suspense fallback={<Loader />}><Support /></Suspense></PrivateRoutes>} />

          {/* Profile Section */}
          <Route path="/profile" element={<PrivateRoutes><Suspense fallback={<Loader />}><ProfileMainPage /></Suspense></PrivateRoutes>} />

          {/* Add Product */}
          <Route path="/add-product" element={<PrivateRoutes><Suspense fallback={<Loader />}><AddProduct /></Suspense></PrivateRoutes>} />
          <Route path="/QR-generated" element={<PrivateRoutes><Suspense fallback={<Loader />}><QRSuccess /></Suspense></PrivateRoutes>} />

          {/* Product Inventory */}
          <Route path="/inventoryView" element={<PrivateRoutes><Suspense fallback={<Loader />}><ProductInventoryView /></Suspense></PrivateRoutes>} />
          <Route path="/product-details/:id" element={<PrivateRoutes><Suspense fallback={<Loader />}><ProductDetails /></Suspense></PrivateRoutes>} />
    
          {/* Warranty */}
          <Route path="/report" element={<PrivateRoutes><Suspense fallback={<Loader />}><ReportSection /></Suspense></PrivateRoutes>} />

          {/* Blockchain */}
          <Route path="/explorer" element={<PrivateRoutes><Suspense fallback={<Loader />}><BlockchainExplorer /></Suspense></PrivateRoutes>} />
          <Route path="/explorer-details" element={<PrivateRoutes><Suspense fallback={<Loader />}><BlockchainExplorerDetails /></Suspense></PrivateRoutes>} />

          {/* Footer */}
          <Route path="/privacy" element={<Suspense fallback={<Loader />}><Privacy /></Suspense>} />
          <Route path="/terms-and-conditions" element={<Suspense fallback={<Loader />}><TermsAndConditions /></Suspense>} />
 
        </Routes>
      </BrowserRouter>
    </div>
  );
}
export default App;
